import { inject, Injectable } from '@angular/core';
import {
  MCAuthoritiesEventsGeneric,
  MCCustomFunctionsParams,
  MCPersonalVehicleImportUtils,
} from '@maslul/common-services';

@Injectable({
  providedIn: 'root',
})
export class PersonalVehicleImportUtils extends MCPersonalVehicleImportUtils {
  private authoritiesEventsGeneric = inject(MCAuthoritiesEventsGeneric);
  override typeCarPersonalVehicleImportChange(
    customFunctionsParams: MCCustomFunctionsParams,
  ): void {
    this.authoritiesEventsGeneric.noImplementFunction(
      customFunctionsParams,
      'typeCarPersonalVehicleImportChange',
    );
  }
}
